import React, { createContext, useContext, useState } from 'react';

const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
  const [currentPost, setCurrentPost] = useState(null);

  return (
    <BlogContext.Provider value={{ currentPost, setCurrentPost }}>
      {children}
    </BlogContext.Provider>
  );
};

export const useBlog = () => useContext(BlogContext); 